import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-ink text-white" data-id="element-0" data-mp="31bic7tnbuwil">
      <MetaPixel data-id="element-1" data-mp="2wjqhr811w6n6" />
      <main data-id="element-2" data-mp="2wj8cjlweui34">
        <Hero data-id="element-3" data-mp="2wifh3h2wjf0a" />
        <Stats data-id="element-4" data-mp="2whx95n6vnccj" />
        <Testimonials data-id="element-5" data-mp="28ufp6dtutik4" />
        <PainPoints data-id="element-6" data-mp="28tw44o8wqe1v" />
        <Volumes data-id="element-7" data-mp="28te3zgj4jfoo" />
        <Bonuses data-id="element-8" data-mp="28sur4e8bzhhi" />
        <Countdown spotsTaken={77} data-id="element-9" data-mp="28sbe9bxjfjac" />
        <Pricing data-id="element-10" data-mp="23vupcfiil0w7" />
        <FAQ data-id="element-11" data-mp="23u9vyt7xrnzx" />
        <Countdown spotsTaken={77} data-id="element-12" data-mp="23utby4e102bb" />
        <ValueStack data-id="element-13" data-mp="3ijxpqrsp22kf" />
      </main>
      <Footer data-id="element-14" data-mp="3ikqz80j1f669" />
    </div>;
}